import { render, staticRenderFns } from "./asideTab.vue?vue&type=template&id=e077d71a&scoped=true&"
import script from "./asideTab.vue?vue&type=script&lang=js&"
export * from "./asideTab.vue?vue&type=script&lang=js&"
import style0 from "./asideTab.vue?vue&type=style&index=0&id=e077d71a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e077d71a",
  null
  
)

export default component.exports